export default [
  { value: 'Fix & Flip', label: 'Fix & Flip' },
  { value: 'HELOC', label: 'HELOC' },
  { value: 'REO', label: 'REO' },
  { value: 'Short Sale', label: 'Short Sale' },
  { value: 'PMI Removal', label: 'PMI Removal' },
];
